<template>
  <router-link :to="link" class="tab_container" :class="active?`active_${color}`:'tab_primary'">
      <span class="tab_text">{{text}}</span>
  </router-link>
</template>

<script>
export default {
    props: {
        text: {type: String, default: "Tab Name"},
        color: {type: String, default: "primary"},
        icon: {type: String, default: null},
        active: {type: Boolean, default: false},
        link: {type: String, default: '#'}
    }

}
</script>

<style lang="scss" scoped>
    a {
        text-decoration: none;
    }
    .tab_container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 13rem ;
        border-radius: 1rem 1rem 0 0;
        font-size: 1.1rem;
        cursor: pointer;
        transition: .3s;
        margin-right: .5rem;
        padding: .7rem 3rem .7rem 3rem;
    }
    
    .tab_primary {
        background-color: #343b43;
        color: #ffffff;
        &:hover {
            background-color: #5dc3b9 ;
        }
    }
    .tab_text{
        white-space: nowrap;
        }
    .active_primary {
        color: #ffffff;
        background-color: #5dc3b9 !important;
        padding-top: 1.2rem;
        // padding-bottom: 1em;
        // height: 3.7rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/global/NavTab.vue